<div *ngFor="let item of items" class="category-items">
  <div class="category-items__item category-items__item--first">
    {{ item.itemName.value }}
  </div>
  <div *ngFor="let license of item.licenses.value" class="category-items__item">
    <div *ngIf="license.contentType?.value" class="category-items__license-type">
      <span *ngIf="license.contentType.value === licenseContentTypeEnum.Text">{{license.text?.value}}</span>
      <svg
        *ngIf="license.contentType.value === licenseContentTypeEnum.Check"
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.54996 9.15L14.025 0.675C14.225 0.475 14.4625 0.375 14.7375 0.375C15.0125 0.375 15.25 0.475 15.45 0.675C15.65 0.875 15.75 1.1125 15.75 1.3875C15.75 1.6625 15.65 1.9 15.45 2.1L6.24996 11.3C6.04996 11.5 5.81663 11.6 5.54996 11.6C5.2833 11.6 5.04996 11.5 4.84996 11.3L0.549963 7C0.349963 6.8 0.25413 6.5625 0.262463 6.2875C0.270796 6.0125 0.374963 5.775 0.574963 5.575C0.774963 5.375 1.01246 5.275 1.28746 5.275C1.56246 5.275 1.79996 5.375 1.99996 5.575L5.54996 9.15Z"
          fill="#6F8E6F"
        />
      </svg>
    </div>
  </div>
</div>
